import { inject } from '@angular/core';
import type { CanActivateChildFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthStore } from '@/features/auth-store.service';
import { APP_URLS } from '@/routes/app.paths';
import type { AppRouteData } from '@/routes/app-route.config';

export const permissionGuard: CanActivateChildFn = (route) => {
  const requiredPermission = (route.data as AppRouteData).permission;
  if (requiredPermission === undefined) {
    return true;
  }

  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.hasPermission(requiredPermission)) {
    return true;
  }

  return router.createUrlTree([APP_URLS.root]);
};
